import coreRenderWebChat from '../../../renderWebChat';
import { ReactWebChat } from '../component/full';

const renderWebChat = coreRenderWebChat.bind(null, ReactWebChat);

export { renderWebChat };
